<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "comparison" });
export let css = "";
export let isScaling = true;
</script>

<!-- eslint-disable max-len -->
<svg
    xmlns = "http://www.w3.org/2000/svg"
    viewBox = "0 0 682.667 682.667"
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = "#272711"
>
    <g
        ><defs
            ><clipPath id="a" clipPathUnits="userSpaceOnUse"
                ><path
                    vector-effect={isScaling ? 'none' : 'non-scaling-stroke'}
                    d="M0 512h512V0H0Z"
                    fill="#000000"
                    opacity="1"
                    data-original="#000000"
                ></path></clipPath
            ></defs
        ><g
            clip-path="url(#a)"
            transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
            ><path
                d="M0 0h221c11.046 0 20 8.954 20 20v400c0 11.046-8.954 20-20 20H0"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(256 36)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path><path
                d="M0 0v-482"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(256 497)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path><path
                d="M0 0v-40"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(15 276)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path><path
                d="M0 0v-40"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(15 376)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path><path
                d="M0 0h-20c-11.046 0-20-8.954-20-20v-20"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(55 476)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path><path
                d="M0 0h40"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(115 476)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path><path
                d="M0 0h41"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(215 476)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path><path
                d="M0 0h40"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(115 36)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path><path
                d="M0 0h41"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(215 36)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path><path
                d="M0 0v40"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(15 136)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path><path
                d="M0 0v-20c0-11.046 8.954-20 20-20h20"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(15 76)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path><path
                d="M0 0h-120"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(376 316)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path><path
                d="m0 0 30 30L0 60"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(346 286)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path><path
                d="M0 0h120"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(136 196)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path><path
                d="m0 0-30-30L0-60"
                style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
                transform="translate(166 226)"
                fill="none"
                stroke-width="30"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-dasharray="none"
                stroke-opacity=""
            ></path></g
        ></g
    >
</svg>